import {useRouterState} from "@tanstack/react-router";

/**
 * Renders a thin animated progress bar at the top of the viewport
 * while TanStack Router is performing a navigation (loading routes, running loaders, etc.).
 *
 * Uses CSS animations only — no external dependency required.
 */
export function AppPendingBar() {
  const isLoading = useRouterState({select: (s) => s.isLoading});

  if (!isLoading) return null;

  return (
    <div
      aria-hidden="true"
      aria-label="Page loading"
      className="fixed top-0 left-0 z-50 h-0.5 w-full overflow-hidden"
      role="progressbar"
    >
      <div className="bg-primary animate-pending-bar h-full w-full origin-left" />
    </div>
  );
}
